<template>
    <div>
        <Header :headerData="headerData"></Header>

        <div class="query_box" >
            <SearchForm
                ref="searchFormRef"
                @handleInputChange="handleInputChange"
                @handlePressEnter="handleSearch"
                @handleSearch="handleSearch"
            ></SearchForm>
        </div>

        <div class="operate_btn">
            <a-button type="primary" size="small" style="margin-right:10px;margin-bottom:10px" @click="handle('add')">
                <PlusOutlined />
                {{ $t('base.add') }}
            </a-button>
        </div>

        <!-- 表格 -->
        <Table
            ref="tableRef"
            :table="table"
            @handleChangePagination="handleChangePagination"
            
        >
            <template v-slot:customCol="{props}">
                <template v-if="props.column.key === 'logo_icon'">
                    <span v-if="!props.record.logo_icon || props.record.logo_icon === '-'">-</span>
                    <a-image v-else :src="props.record.logo_icon" alt="" srcset="" :width="50"></a-image>
                </template>
                <template v-if="props.column.key === 'small_logo_icon'">
                    <span v-if="!props.record.small_logo_icon || props.record.small_logo_icon === '-'">-</span>
                    <a-image v-else :width="20" :src="props.record.small_logo_icon"></a-image>
                </template>
            </template>

            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button size="small" :disabled="props.record.status_val == 1" @click="handle('edit',props.record)">{{ $t('base.edit') }}</a-button>
                    <a-divider type="vertical" />
                    <a-button size="small" :disabled="props.record.status_val == 1" @click="handle('detail',props.record)">{{ $t('base.detail') }}</a-button>
                </template>
            </template>
        </Table>


        <!-- 新增租户 -->
        <AddTenant 
            :visible="visible" 
            :isEdit="isEdit" 
            :detailData="detailData" 
            @handleCancel="handleCancel"
            @handleSave="handleSave"
        ></AddTenant>

        <!-- 详情 -->
        <a-drawer
            v-model:open="open"
            class="custom-class"
            :title="detail_title"
            width="88%"
            placement="right"
            @after-open-change="afterOpenChange"
        >
            <DetailTenant :detailData="detailData"></DetailTenant>
        </a-drawer>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, onUnmounted } from "vue";
    import Table from "@/components/Table.vue";
    import Header from "@/layouts/component/Header.vue";
    import SearchForm from "./SearchForm.vue";
    import AddTenant from "./AddTenant.vue";
    import DetailTenant from "./DetailTenant.vue";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { TenantApi } from '@/api/TenantApi.js';
    import { getWeek } from '@/hooks/useGetWeek';
    import { formatTimestamp, debounce } from '@/utils/global';

    const { t } = useI18n()

    const headerData = ref({
        menu:'menu.Tenant',
        menu_desc: 'menu.subTenant',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })

    const searchFormRef = ref(null)
    const visible = ref(false)
    const open = ref(false)
    const isEdit = ref(false)
    const rowData = ref({})
    const detailData = ref({})
    const detail_title = ref('')

    const table = ref({
        data: [],
        columns: [
            {
                title: t('tenant.tenant_name'), // 组织名称
                dataIndex: 'tenant_name',
                key: 'tenant_name',
                width: 150,
                resizable: true,
                ellipsis: true,
                fixed: 'left',
            },
            {
                title: t('tenant.tenant_code'), // 组织编码
                dataIndex: 'tenant_code', 
                key: 'tenant_code',
                width: 150,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.domain_name'), // 域名
                dataIndex: 'domain_name',
                key: 'domain_name',
                width: 220,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.app_id'), // appId
                dataIndex: 'app_id',
                key: 'app_id',
                width: 150,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.project_no'), // 项目编号
                dataIndex: 'project_no',
                key: 'project_no',
                width: 120,
                resizable: true,
                ellipsis: true,
            },
            // {
            //     title: t('tenant.jwt_secret'), // jwtSecret
            //     dataIndex: 'jwt_secret',
            //     key: 'jwt_secret',
            //     width: 150,
            //     resizable: true,
            //     ellipsis: true,
            // },
            {
                title: t('tenant.logo_icon'), // 大logo
                dataIndex: 'logo_icon',
                key: 'logo_icon',
                width: 180,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.small_logo_icon'), // 小logo
                dataIndex: 'small_logo_icon',
                key: 'small_logo_icon',
                width: 160,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.privacy_version'), // 大logo
                dataIndex: 'privacy_version',
                key: 'privacy_version',
                width: 180,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.warranty_version'), // 小logo
                dataIndex: 'warranty_version',
                key: 'warranty_version',
                width: 160,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.picture_path'), // 图片地址 
                dataIndex: 'picture_path',
                key: 'picture_path',
                width: 180,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.file_path'), // 文件地址 
                dataIndex: 'file_path',
                key: 'file_path',
                width: 160,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.avatar_path'), // 头像地址 
                dataIndex: 'avatar_path',
                key: 'avatar_path',
                width: 220,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.vali_user_path'), // 激活用户地址
                dataIndex: 'vali_user_path',
                key: 'vali_user_path',
                width: 150,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.firmware_path'), // 固件地址 
                dataIndex: 'firmware_path',
                key: 'firmware_path',
                width: 150,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.fault_path'), // 故障地址 
                dataIndex: 'fault_path',
                key: 'fault_path',
                width: 150,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.del_user_path'), // 删除用户地址 
                dataIndex: 'del_user_path',
                key: 'del_user_path',
                width: 150,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.fault_font_color'), // 故障字体颜色
                dataIndex: 'fault_font_color',
                key: 'fault_font_color',
                width: 150,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('tenant.fault_background_color'), // 故障背景颜色 
                dataIndex: 'fault_background_color',
                key: 'fault_background_color',
                width: 190,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('base.operate'),
                key: 'action',
                fixed: 'right',
                width: 180,
                resizable: true,
            },
        ],
        configs: {
            table: {
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 580,
            },
            rowSelection: false,
            loading: false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,
                current:1,
                pageSize:10,
                showSizeChanger: true,
                pageSizeOptions:['10','20','50'],
                total:0,
                // showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const handle = (type, row) => {
        switch(type){
            case 'add':
                visible.value = true
                isEdit.value = false
                break;
            case 'edit':
                isEdit.value = true
                rowData.value = row
                getTenantDetail('edit')
                break;
            case 'detail':
                rowData.value = row
                detail_title.value = row.tenant_name
                getTenantDetail('detail')
                break;
        }
    }

    const handleInputChange = debounce((formData) => {
        table.value.configs.pagination.current = 1
        getList()
    }, 500)

    const handleSearch = (formData) => {
        table.value.configs.pagination.current = 1
        getList()
    }

    // 分页
    const handleChangePagination =  (config, data)=> {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    const handleCancel = () => {
        visible.value = false
    }

    const handleSave = () => {
        visible.value = false
        getList()
    }

    const getList = async () => {
        let param = {
            tenant_name: searchFormRef.value.formData.tenant_name.trim(),
            tenant_code: searchFormRef.value.formData.tenant_code.trim(),
            app_id: searchFormRef.value.formData.app_id.trim(),
            project_no: searchFormRef.value.formData.project_no.trim(),
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        console.log(searchFormRef.value, 'searchFormRef.value.formData')
        let res = await TenantApi.getInstance().getTenantList(param, page_num, page_size)
        if(res.code === 0){
            res.data.records.forEach(i=>{
                i.logo_icon = !i.logo_icon? '-' : i.logo_icon
                i.small_logo_icon = !i.small_logo_icon? '-' : i.small_logo_icon
                i.picture_path = !i.picture_path? '-' : i.picture_path
                i.file_path = !i.file_path? '-' : i.file_path
                i.avatar_path = !i.avatar_path? '-' : i.avatar_path
                i.vali_user_path = !i.vali_user_path? '-' : i.vali_user_path
                i.firmware_path = !i.firmware_path? '-' : i.firmware_path
                i.warranty_version = !i.warranty_version? '-' : i.warranty_version
                i.privacy_version = !i.privacy_version? '-' : i.privacy_version
                // i.jwt_secret = i.jwt_secret.replace(/^(.{4}).*(.{4})$/, '$1******$2')
            })
            table.value.data = res.data.records
            table.value.configs.pagination.total = res.data.total

            table.value.configs.loading = false
        }else{
            message.error(res.msg || res.message)
            table.value.configs.loading = false
        }
    }

    const getTenantDetail = async (type) => {
        let res = await TenantApi.getInstance().getTenantDetail(rowData.value.id)
        if(res.code === 0){
            detailData.value = JSON.parse(JSON.stringify(res.data))
            if(type === 'detail') open.value = true
            if(type === 'edit') visible.value = true
        }else{
            message.error(res.msg || res.message)
        }
    }

    onMounted(()=>{
        getList()
    })

</script>

<style lang="scss" scoped>
::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}
::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}
</style>